// index.ts
import {
  toLinear,
  easingFactory
} from "@foundit/motion-blur";
function microAnimation({
  composite,
  debug = false,
  duration = 300,
  easing = "linear",
  element,
  fill = "forwards",
  transformEnd,
  transformInit,
  pseudoElement
}) {
  const elementArr = Array.isArray(element) ? element : [element];
  if (elementArr.filter(Boolean).length === 0) {
    const err = "No element passed to microAnimation";
    throw new Error(err);
  }
  const transformEndArr = Array.isArray(transformEnd) ? transformEnd : [transformEnd];
  const targetProperties = [
    ...new Set(
      transformEndArr.reduce((acc, transformObj) => {
        return [...acc, ...Object.keys(transformObj)];
      }, [])
    )
  ];
  debuglog("targetProps", targetProperties);
  const tasks = [];
  elementArr.forEach((el) => {
    const task = new Promise((resolve) => {
      el.currentAnimation?.pause();
      const computedStyle = getComputedStyle(el);
      const transformStart = transformInit ?? targetProperties.reduce((acc, key) => {
        if (key !== "offset")
          acc[key] = computedStyle[key]?.toString();
        return acc;
      }, {});
      debuglog(transformInit, transformEndArr);
      if (el.currentAnimation) {
        const timing = el.currentAnimation.effect?.getComputedTiming();
        const activeDuration = parseInt(String(timing?.activeDuration));
        const activeProgress = timing?.progress ?? 0;
        duration -= activeDuration - activeProgress * activeDuration;
      }
      el.currentAnimation?.cancel();
      el.currentAnimation = el.animate([transformStart, ...transformEndArr], {
        composite,
        duration,
        easing,
        fill,
        pseudoElement
      });
      el.currentAnimation.onfinish = resolve;
      el.currentAnimation.oncancel = null;
    });
    tasks.push(task);
  });
  return Promise.allSettled(tasks);
  function debuglog(_, ...rest) {
    if (debug)
      console.log(arguments);
  }
}
export {
  easingFactory,
  microAnimation,
  toLinear
};
